import { OnInit, Component, Input } from '@angular/core';
import { Wrapper } from '../wrapper.component';
import { BrandOption, BrandingData, BrandingSelectData } from 'globals/store/publish.data';
import { ManageBrandingComponent, ManageBrandingData } from './manage-branding.component';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { brandDataReselector } from '../../store/reselectors/publish.reselector';
import { EventListInfo, EventListsData, SortedEventListPublishInstances } from 'globals/store/share.event-lists.data';
import { Dictionary } from '@ngrx/entity';
import { JoiEvent } from 'globals/store/events.data';
import { BrandingBlockWrapperComponent } from './branding-block.component';
import { BrandTemplateComponent } from './brand-template.component';
import { BrandImageComponent } from './brand-image.component';
import { SocialLinksComponent } from '../social-links/social-links.component';
import { FooterLinksComponent } from './footer-links.component';
import { CommonModule, UpperCasePipe } from '@angular/common';

@Component({
    selector: 'event-list-builder',
    templateUrl: "./event-lists-builder.html",
    styles: [`
  img.header, img.footer { cursor: pointer; margin: 0 auto; display: flex; }
  branding-block, branding-text, img.header, img.footer { margin-bottom: 20px; width: 1330px; max-width: 100%; }
  event-list { margin-bottom: 20px; display: block; }
  brand-template { margin-top: 40px; }
`],
    styleUrls: ['../publish-timeline/publish-timeline.scss'],
    standalone: true,
    imports: [BrandingBlockWrapperComponent, CommonModule, BrandTemplateComponent, BrandImageComponent, SocialLinksComponent, FooterLinksComponent, UpperCasePipe],
})
export class EventListsBuilderComponent extends Wrapper<EventListsBuilderComponent> implements OnInit {
  @Input() eventListInfo: EventListInfo
  @Input() accountId: string
  @Input() upcomingAndPastEventLists: SortedEventListPublishInstances
  @Input() publishesLoading = 0
  @Input() eventListsFullData: EventListsData
  brandingData: BrandingData
  events: Dictionary<JoiEvent>

  ngOnInit() {
    const brandingSelectData: BrandingSelectData = {
      type: 'list',
      eventListId: this.eventListInfo.publishCode,
      accountId: this.accountId
    }
    this.selectProp(brandDataReselector, brandingSelectData, 'brandingData')
    this.subProp(this.store.select('events', 'entities'), 'events')
  }

  saveEventListInfo () {
    console.log("Should be saving event list info")
    this.accountService.updateEventListInfo(this.accountId, this.eventListInfo)
  }

  async editBranding(brandingOption: BrandOption) {
    console.log("Should be opening branding options dialogue and changing " + brandingOption)
    const data: ManageBrandingData = { selectedTab: brandingOption, type: 'list', eventListId: this.eventListInfo.publishCode, accountId: this.accountId, outsideEvent: true, onAccount: true }
    await openDialogGetResult(this.dialog, ManageBrandingComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
  }

}